import React from 'react';
import { motion } from 'framer-motion';
import { studyBridge } from '../../../data/snak';
import { inputsOct } from '../../../data/teaser';
const EASE = [0.23, 1, 0.32, 1] as const;
export function StudyBridgePage() {
  return <div className="relative flex flex-1 flex-col bg-deep px-10 py-7" data-id="element-238" data-mp="2kwfbmo6geqrt">
      <div className="grid-field pointer-events-none absolute inset-0 opacity-70" aria-hidden="true" data-id="element-239" data-mp="2gtsrzajxsc5p" />

      <div className="relative flex min-h-0 flex-1 gap-10" data-id="element-240" data-mp="2ut1uj7f7z7r7">
        <div className="flex min-h-0 max-w-xl flex-1 flex-col" data-id="element-241" data-mp="2urh1xncgtyvz">
          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.28,
          ease: EASE
        }} className="font-display text-[31px] font-semibold leading-[1.06] tracking-tight text-paper" data-id="element-242" data-mp="2pu7euecjtzbb">
            {studyBridge.headline}
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.26,
          delay: 0.08,
          ease: EASE
        }} className="mt-4 text-[14px] leading-relaxed text-sky/75" data-id="element-243" data-mp="38l8cmz1xnota">
            {studyBridge.copy}
          </motion.p>

          <motion.figure initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.14,
          ease: EASE
        }} className="relative mt-5 min-h-0 flex-1 overflow-hidden rounded-xl border border-sky/15 bg-ink" data-id="element-244" data-mp="2qr2qm6j5pb5h">
            <img src={inputsOct.src} alt={inputsOct.alt} className="absolute inset-0 h-full w-full object-cover object-center" data-id="element-245" data-mp="34qatpaifx3ey" />
            <div className="scanlines pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-246" data-mp="39jn6mndrblrv" />
            <figcaption className="absolute bottom-3 left-4 right-4 text-[9px] uppercase tracking-micro text-sky/65" data-id="element-247" data-mp="3ei844f1mjrcm">
              {inputsOct.caption}
            </figcaption>
          </motion.figure>

          <motion.p initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.26,
          delay: 0.34,
          ease: EASE
        }} className="mt-5 border-l-2 border-mint pl-4 font-display text-[19px] leading-snug text-paper" data-id="element-248" data-mp="1ocbm9kul5umb">
            {studyBridge.question}
          </motion.p>
        </div>

        <div className="flex w-[34%] shrink-0 flex-col border-l border-sky/15 pl-9" data-id="element-249" data-mp="1sccdk62sa0as">
          <motion.div initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.28,
          delay: 0.1,
          ease: EASE
        }} data-id="element-250" data-mp="271i99k2ex8dx">
            <p className="font-display text-[58px] font-bold leading-none tracking-tight tabular-nums text-mint" data-id="element-251" data-mp="2g2geu6si1nym">
              2,355
            </p>
            <p className="mt-2 text-[10px] uppercase tracking-micro text-sky/60" data-id="element-252" data-mp="2c01x5q0kgu8x">
              DME eyes analysed
            </p>
          </motion.div>

          <p className="mt-8 text-[10px] uppercase tracking-micro text-sky/60" data-id="element-253" data-mp="howw8tgv6vxa">
            Five familiar OCT variables
          </p>
          <div className="mt-3 flex flex-col" data-id="element-254" data-mp="7m1dnxh33bv1">
            {studyBridge.variables.map((v, i) => <motion.div key={v} initial={{
            opacity: 0,
            x: -6
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.24,
            delay: 0.16 + i * 0.05,
            ease: EASE
          }} className="flex items-baseline gap-3 border-b border-sky/15 py-2" data-id="element-255" data-mp="bnmkb130ytws" data-mpi={i}>
                <span className="font-display text-[10px] font-bold tabular-nums text-sky/40" data-id="element-256" data-mp="3p06i26kwd70u">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="font-display text-[18px] font-semibold tracking-tight text-paper" data-id="element-257" data-mp="3b2qagrqv777i">
                  {v}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </div>;
}